/* eslint-disable */
const headers = [
  {
    text: 'Creator',
    align: 'center',
    sortable: true,
    value: 'userHandle',
    class: 'creator-handle-column',
    cellClass: 'creator-handle-column'
  },
  {
    text: 'Campaign',
    align: 'center',
    sortable: true,
    value: 'campaignName'
  },
  {
    text: 'Content Storyboard Status',
    align: 'center',
    sortable: true,
    value: 'conceptStatus'
  },
  {
    text: 'Content Storyboard',
    align: 'center',
    sortable: true,
    value: 'contentScripts'
  },
  // {
  //   text: 'Posting Link',
  //   align: 'center',
  //   sortable: true,
  //   value: 'postingLink'
  // },
  {
    text: 'Pending Item Submission Date',
    align: 'center',
    sortable: true,
    value: 'shootDate'
  },
  {
    text: 'Deliverables',
    align: 'center',
    sortable: true,
    value: 'deliverableDetails'
  },
  {
    text: 'Content Feature/pillar',
    align: 'center',
    sortable: true,
    value: 'contentFeature'
  },
  {
    text: 'Remark',
    align: 'center',
    sortable: true,
    value: 'kobeRemark'
  },
  {
    text: 'Action',
    align: 'center',
    sortable: true,
    value: 'action'
  }
]

const conceptStatuses = [
  {
    text: 'Pending creator concept submission',
    value: 1,
    color: '#e8eaed'
  },
  {
    text: 'Concept submitted, pending client approval',
    value: 2,
    color: '#ffcfc9'
  },
  {
    text: 'Concept pending revision',
    value: 3,
    color: '#ffc8aa'
  },
  {
    text: 'Concept revised, pending client approval',
    value: 4,
    color: '#ffe5a0'
  },
  {
    text: 'Concept approved, proceed to brief influencers to shoot',
    value: 5,
    color: '#d4edbc'
  },
  {
    text: 'Draft submitted on IMS',
    value: 6,
    color: '#bfe1f6'
  },
  {
    text: 'Draft pending revisions',
    value: 7,
    color: '#c6dbe1'
  },
  {
    text: 'Draft revised, pending final approval',
    value: 8,
    color: '#e6cff2'
  },
  {
    text: 'Draft approved',
    value: 9,
    color: '#11734b'
  }
]

export default Object.assign({}, {
  headers,
  conceptStatuses
})



// WEBPACK FOOTER //
// ./src/components/views/Pairing/CreatorConcept/config.js